import { createConsola } from "consola";
const LOGGER_NAME = "nuxt-auth-sanctum";
export function useSanctumLogger(logLevel) {
  const envSuffix = import.meta.server ? "ssr" : "csr";
  const loggerName = LOGGER_NAME + ":" + envSuffix;
  return createConsola({ level: logLevel }).withTag(loggerName);
}
